import React from "react";
import PropTypes from "prop-types";

import FullPageLoader from "../FullPageLoader";

import { withRouter } from "js/components/Root/withRouter";

import * as authApi from "js/api/authApi";
import { LoginDelegatedRequest, LoginFailure } from "js/api/authApi";
import { useUserSessionStore } from "stores/v2/userSessionStore";

type MyProps = {
	router: IComponentRouter;
};

class LoginGoogleCallback extends React.Component<MyProps> {
	handleLoginFailure = (error: unknown) => {
		useUserSessionStore.getState().handleAuthenticationFailure(error as LoginFailure | authApi.ApiError<authApi.ServerError>);
		this.props.router.navigate("/login");
	};

	componentDidMount() {
		const deviceid = this.props.router.queryString.state;

		const loginRequest: LoginDelegatedRequest = {
			code: this.props.router.queryString.code,
			deviceid: deviceid,
		};

		authApi
			.loginDelegated("google", loginRequest)
			.then((res) => {
				useUserSessionStore
					.getState()
					// eslint-disable-next-line @typescript-eslint/ban-ts-comment
					// @ts-ignore Ignore for now
					.authenticate(res)
					.then(() => this.props.router.navigate("/"))
					.catch(this.handleLoginFailure);
			})
			.catch(this.handleLoginFailure);
	}

	render() {
		return <FullPageLoader message="Logging in with Google" />;
	}

	static propTypes = {
		router: PropTypes.object.isRequired,
	};
}

export default withRouter(LoginGoogleCallback);
